import type { PublicWebinarSession } from '@/features/webinar/types';

/**
 * Les réponses HTTP peuvent arriver dans le désordre. Sur une connexion dégradée, une requête
 * lancée avant le démarrage répond après une requête plus récente et réinstalle un statut périmé,
 * ce qui suffit à relancer l'aller-retour entre la salle d'attente et le live.
 *
 * On ne refuse qu'un seul recul, celui qui provoque la boucle : revenir à « à venir » alors que la
 * session a déjà démarré. Le back n'écrit jamais ce statut, il n'est que la valeur initiale, donc
 * le recevoir après un démarrage ne peut venir que d'une réponse en retard.
 * Les autres transitions restent ouvertes, y compris terminée vers en cours, qui est réellement
 * atteignable par l'entrée d'un modérateur.
 */
const STARTED_STATUSES = new Set(['IN_PROGRESS', 'FINISHED']);

export function isPublicSessionApplicable(
  current: PublicWebinarSession | null | undefined,
  incoming: PublicWebinarSession | null | undefined,
): boolean {
  if (!incoming) return false;
  if (!current) return true;

  const currentSession = current.session;
  const incomingSession = incoming.session;
  if (!currentSession || !incomingSession) return true;

  // Session différente : rien à comparer, la nouvelle remplace l'ancienne.
  if (currentSession.id !== incomingSession.id) return true;

  return !(incomingSession.status === 'UPCOMING' && STARTED_STATUSES.has(currentSession.status));
}
